import { gql } from '@apollo/client'

export const GET_ALL_LOGS = gql`
  query GetAllLogs(
    $offset: Int
    $limit: Int
    $name: String
    $id: Int
    $activity: String
    $query: String
    $logType: String
  ) {
    allLogs(
      offset: $offset
      limit: $limit
      name: $name
      id: $id
      activity: $activity
      query: $query
      logType: $logType
    ) {
      logs {
        log_id
        user_name
        activity_time
        activity
        app_log_id
        user_log_id
        rich_activity
      }
      total
    }
  }
`

export const GET_APP_LOGS = gql`
  query GetAppLogs(
    $offset: Int
    $limit: Int
    $name: String
    $id: Int
    $activity: String
  ) {
    appLogs(
      offset: $offset
      limit: $limit
      name: $name
      id: $id
      activity: $activity
    ) {
      log_id
      user_name
      activity_time
      activity
    }
  }
`
